// Offline queue — stores failed mutations in localStorage and replays on reconnect

export interface QueuedRequest {
  id: string
  method: string
  url: string
  data: any
  headers: Record<string, string>
  timestamp: number
  label: string  // human-readable description shown in sync banner
}

const QUEUE_KEY = 'hseq_offline_queue'

export function getQueue(): QueuedRequest[] {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]')
  } catch {
    return []
  }
}

export function enqueue(req: Omit<QueuedRequest, 'id' | 'timestamp'>): void {
  const queue = getQueue()
  queue.push({ ...req, id: crypto.randomUUID(), timestamp: Date.now() })
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue))
  window.dispatchEvent(new Event('offline-queue-changed'))
}

export function dequeue(id: string): void {
  const queue = getQueue().filter(r => r.id !== id)
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue))
  window.dispatchEvent(new Event('offline-queue-changed'))
}

export function clearQueue(): void {
  localStorage.removeItem(QUEUE_KEY)
  window.dispatchEvent(new Event('offline-queue-changed'))
}

export function queueLength(): number {
  return getQueue().length
}

// Label helper — derives a human-readable description from the request
export function requestLabel(method: string, url: string, data: any): string {
  if (url.includes('/incidents') && method === 'POST') return 'Report incident'
  if (url.includes('/checkin'))                        return 'Lone worker check-in'
  if (url.includes('/lone-worker') && method === 'POST') return 'Lone worker action'
  if (url.includes('/audits') && method === 'POST')   return 'Audit response'
  if (url.includes('/corrective-actions'))             return 'Corrective action'
  if (url.includes('/competencies'))                   return 'Competency update'
  return `${method} ${url.split('/').slice(-2).join('/')}`
}
